import { Brand, ImageData } from "./Parse";
import { federateUrl } from "../../Utils/Utils";

const DESKTOP_SVG = `
<?xml
version="1.0" encoding="UTF-8"?>
<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64.57 35" fill="currentColor">
    <path d="M6.27,10.22h4.39l6.2,14.94h-4.64l-3.92-9.92-2.59,6.51h3.08l1.23,3.41H0l6.27-14.94ZM22.03,13.32c.45,0,.94.04,1.43.16v-3.7h3.88v14.72c-.89.4-2.81.89-4.73.89-3.48,0-6.47-1.98-6.47-5.93s2.88-6.13,5.89-6.13ZM22.52,22.19c.36,0,.65-.07.94-.16v-5.42c-.29-.11-.58-.16-.96-.16-1.27,0-2.45.94-2.45,2.92s1.2,2.81,2.47,2.81ZM34.25,13.32c3.23,0,5.98,2.18,5.98,6.02s-2.74,6.02-5.98,6.02-6-2.18-6-6.02,2.72-6.02,6-6.02ZM34.25,22.13c1.11,0,2.14-.89,2.14-2.79s-1.03-2.79-2.14-2.79-2.12.89-2.12,2.79.96,2.79,2.12,2.79ZM41.16,9.78h3.9v3.7c.47-.09.96-.16,1.45-.16,3.03,0,5.84,1.98,5.84,5.86,0,4.1-2.99,6.18-6.53,6.18-1.52,0-3.46-.31-4.66-.87v-14.72ZM45.91,22.17c1.34,0,2.56-.96,2.56-2.94,0-1.85-1.2-2.72-2.5-2.72-.36,0-.65.04-.91.16v5.35c.22.09.51.16.85.16ZM58.97,13.32c2.92,0,5.6,1.87,5.6,5.64,0,.51-.02,1-.09,1.49h-7.27c.4,1.32,1.56,1.94,3.01,1.94,1.18,0,2.27-.29,3.5-.82v2.97c-1.14.58-2.5.82-3.9.82-3.7,0-6.58-2.23-6.58-6.02s2.61-6.02,5.73-6.02ZM60.93,18.02c-.2-1.27-1.05-1.78-1.92-1.78s-1.58.54-1.87,1.78h3.79Z"/>
</svg>
`.trim();

const MOBILE_SVG = `
<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 18 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path id="Logo" d="M17.5512 15.9999H13.8827C13.7233 16.0027 13.5666 15.9587 13.4326 15.8735C13.2987 15.7882 13.1934 15.6656 13.1303 15.5211L9.1476 6.3291C9.1372 6.29332 9.11539 6.26179 9.08542 6.23919C9.05545 6.2166 9.0189 6.20413 8.98118 6.20365C8.94347 6.20316 8.9066 6.21469 8.87605 6.2365C8.84549 6.25832 8.82286 6.28928 8.81152 6.32478L6.32954 12.161C6.31607 12.1925 6.31072 12.2269 6.31397 12.261C6.31721 12.2951 6.32896 12.3279 6.34815 12.3565C6.36735 12.385 6.39339 12.4084 6.42398 12.4246C6.45456 12.4408 6.48872 12.4493 6.52343 12.4493H9.25162C9.33426 12.4493 9.41508 12.4733 9.48398 12.5183C9.55288 12.5634 9.60681 12.6275 9.63905 12.7026L10.8335 15.3264C10.8652 15.4 10.8778 15.4802 10.8704 15.5599C10.863 15.6395 10.8357 15.7161 10.791 15.7828C10.7463 15.8495 10.6856 15.9042 10.6142 15.9421C10.5429 15.98 10.4631 15.9998 10.3821 15.9999H0.450101C0.375399 15.9994 0.301967 15.9808 0.236351 15.9455C0.170735 15.9103 0.114973 15.8595 0.0740362 15.7979C0.0330997 15.7362 0.00826021 15.6655 0.00173221 15.592C-0.00479579 15.5185 0.00719033 15.4446 0.0366223 15.3769L6.35412 0.526466C6.41869 0.369291 6.52976 0.234984 6.67284 0.141079C6.81593 0.0471732 6.98437 -0.00196688 7.15618 7.38373e-05H10.7999C10.9718 -0.00217252 11.1403 0.0468839 11.2835 0.140814C11.4266 0.234745 11.5377 0.369168 11.6021 0.526466L17.9633 15.3769C17.9927 15.4445 18.0048 15.5183 17.9983 15.5917C17.9919 15.665 17.9672 15.7357 17.9264 15.7973C17.8856 15.859 17.83 15.9097 17.7646 15.9451C17.6991 15.9804 17.6258 15.9992 17.5512 15.9999V15.9999Z" />
</svg>
`.trim();

type RenderBrandData = {
  href: string;
  label: string;
  isDarkBg: boolean;
  imageData: ImageData;
};

const renderBrand = (data: RenderBrandData): HTML => {
const { href, label, isDarkBg, imageData } = data;

  // Fallback behavior:
  // - If only light exists, use it for dark too
  // - If only dark exists, use it for light too
  const desktopLightSrc = imageData.lightThemeImageSrc?.trim() || imageData.darkThemeImageSrc?.trim() || '';
  const desktopDarkSrc = imageData.darkThemeImageSrc?.trim() || imageData.lightThemeImageSrc?.trim() || '';
  const mobileLightSrc = imageData.mobileLightThemeImageSrc?.trim() || imageData.mobileDarkThemeImageSrc?.trim() || '';
  const mobileDarkSrc = imageData.mobileDarkThemeImageSrc?.trim() || imageData.mobileLightThemeImageSrc?.trim() || '';

  const desktopLightAlt = imageData.lightThemeImageAlt || imageData.darkThemeImageAlt || '';
  const desktopDarkAlt = imageData.darkThemeImageAlt || imageData.lightThemeImageAlt || '';
  const mobileLightAlt = imageData.mobileLightThemeImageAlt || imageData.mobileDarkThemeImageAlt || '';
  const mobileDarkAlt = imageData.mobileDarkThemeImageAlt || imageData.mobileLightThemeImageAlt || '';

  const hasDesktopLight = !!desktopLightSrc;
  const hasDesktopDark = !!desktopDarkSrc;
  const hasMobileLight = !!mobileLightSrc;
  const hasMobileDark = !!mobileDarkSrc;

  const desktopLightImg = hasDesktopLight
    ? `<img src="${federateUrl(desktopLightSrc)}" alt="${desktopLightAlt}" />`
    : '';
  const desktopDarkImg = hasDesktopDark
    ? `<img src="${federateUrl(desktopDarkSrc)}" alt="${desktopDarkAlt}" />`
    : '';

  const mobileLightImg = hasMobileLight
    ? `<img src="${federateUrl(mobileLightSrc)}" alt="${mobileLightAlt}" />`
    : '';
  const mobileDarkImg = hasMobileDark
    ? `<img src="${federateUrl(mobileDarkSrc)}" alt="${mobileDarkAlt}" />`
    : '';

  const desktopSvg = hasDesktopLight && hasDesktopDark ? '' : DESKTOP_SVG;
  const mobileSvg = hasMobileLight && hasMobileDark ? '' : MOBILE_SVG;

  return `<div class="feds-brand-container${isDarkBg ? ' feds-dark-bg' : ''}">
    <a href="${href}" class="feds-brand" daa-ll="Brand" aria-label="${label}">
      <span class="feds-brand-image desktop-brand">
        ${desktopLightImg}
        ${desktopDarkImg}
        ${desktopSvg}
      </span>
      <span class="feds-brand-image mobile-brand">
        ${mobileLightImg}
        ${mobileDarkImg}
        ${mobileSvg}
      </span>
    </a>
  </div>`.trim();
};

export const brand = (brandData: Brand): HTML => {
  const { data } = brandData;
  return renderBrand(data);
};